module.exports = __webpack_public_path__ + "img/home_page_no_data_illustation.d935fda2.png";